module.exports = __webpack_public_path__ + "static/5-ede9ef411f4d1d292169dce06f61c59e.png";